const SeoOpenGraph = `
  fragment SeoOpenGraph on SeoOpenGraph {
        description
        facebookAppId
        title
  }
`

export default SeoOpenGraph
